module.exports = __webpack_public_path__ + "media/images/apple_black_logo-0546eb8f.svg";